import { ActionTypes } from './constants';
import * as Models from './models';

export const getProjectData: Models.ActionCreator.GetProjectData = rootDocumentId => ({
  type: ActionTypes.GET_PROJECT_DATA,
  payload: {
    rootDocumentId,
  },
});
